import React from "react";
import { Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import {
    Email as EmailIcon,
    Person as PersonIcon,
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";

import { ADDRESS_FIELD_LABELS } from "../../../utils/addressData";
import { CONTACT_FIELD_LABELS } from "../../../utils/contactValidation";

export default function RegistrationFields({
    formData,
    fieldErrors,
    showPw,
    showPw2,
    onChange,
    onToggleShowPw,
    onToggleShowPw2,
}) {
    return (
        <>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Vorname"
                    name="firstname"
                    value={formData.firstname}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.firstname)}
                    helperText={fieldErrors.firstname || ""}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <PersonIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Nachname"
                    name="lastname"
                    value={formData.lastname}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.lastname)}
                    helperText={fieldErrors.lastname || ""}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <PersonIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Benutzername"
                    name="username"
                    value={formData.username}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.username)}
                    helperText={fieldErrors.username || ""}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label={CONTACT_FIELD_LABELS.email}
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.email)}
                    helperText={fieldErrors.email || ""}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <EmailIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={8}>
                <TextField
                    label={ADDRESS_FIELD_LABELS.street}
                    name="street"
                    value={formData.street}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.street)}
                    helperText={fieldErrors.street || ""}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="Nr."
                    name="houseNumber"
                    value={formData.houseNumber}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.houseNumber)}
                    helperText={fieldErrors.houseNumber || ""}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label={ADDRESS_FIELD_LABELS.zip}
                    name="zip"
                    value={formData.zip}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.zip)}
                    helperText={fieldErrors.zip || ""}
                />
            </Grid>
            <Grid item xs={12} sm={8}>
                <TextField
                    label={ADDRESS_FIELD_LABELS.city}
                    name="city"
                    value={formData.city}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.city)}
                    helperText={fieldErrors.city || ""}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Passwort (min. 8 Zeichen)"
                    name="password"
                    type={showPw ? "text" : "password"}
                    value={formData.password}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.password)}
                    helperText={fieldErrors.password || ""}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton edge="end" onClick={onToggleShowPw} aria-label="Passwort anzeigen">
                                    {showPw ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Passwort wiederholen"
                    name="confirmPassword"
                    type={showPw2 ? "text" : "password"}
                    value={formData.confirmPassword}
                    onChange={onChange}
                    fullWidth
                    required
                    error={Boolean(fieldErrors.confirmPassword)}
                    helperText={fieldErrors.confirmPassword || ""}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton edge="end" onClick={onToggleShowPw2} aria-label="Passwort anzeigen">
                                    {showPw2 ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
        </>
    );
}
